import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as rawBase64Decode, encode as base64_encode } from 'base-64';
import { showDuplicateLoginAlert } from '../../components/Auth/DuplicateLoginAlert';

const normalizeHistoryNfeResponse = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  let normalizedValue = value.trim();

  if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
    normalizedValue = JSON.parse(normalizedValue);
  }

  return normalizedValue;
};

const base64_decode = (value) => rawBase64Decode(normalizeHistoryNfeResponse(value));

const isHistoryNfeAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    let normalizedValue = value.trim();

    if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
    }

    return normalizedValue === 'erro_auth';
  });
};

const handleHistoryNfeError = (xhr, reject, rejectMessage) => {
  if (isHistoryNfeAuthError(xhr)) {
    showDuplicateLoginAlert();
  }

  reject([400, { message: rejectMessage }]);
};

const getSession = () => {
  const usersRt = sessionStorage.getItem('ddesp');
  return usersRt !== null ? JSON.parse(base64_decode(usersRt)) : null;
};

const ajaxHistoryNfeEvent = ({
  type,
  pp,
  ll,
  dd,
  tk,
  parseType = 'base64',
  rejectMessage = 'erro',
  extraData = {},
  routeField = 'll',
  encodeRoute = true,
  encodeDd = true,
  safeParse = false,
}) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
      type,
      dataType: 'text',
      headers: {
        Authorization: 'Bearer ' + tk,
      },
      data: {
        pp: base64_encode(pp),
        [routeField]: encodeRoute ? base64_encode(ll) : ll,
        ...(encodeDd ? { dd: base64_encode(JSON.stringify(dd)) } : {}),
        tk,
        ...extraData,
      },
      success: function (data) {

        // safeParse: 'sessao_expirada'/'erro_auth' chegam em texto puro (não base64) e o decode lançaria
        // dentro do callback, deixando a Promise pendente. Aqui a sessão expirada é entregue ao interceptor
        // do axios (limpa a sessão e redireciona) e o erro_auth segue o mesmo caminho do erro de requisição.
        if (safeParse) {
          const bruto = normalizeHistoryNfeResponse(data);
          if (bruto === 'sessao_expirada') {
            resolve([200, bruto]);
            return;
          }
          if (bruto === 'erro_auth') {
            handleHistoryNfeError({ responseText: bruto }, reject, rejectMessage);
            return;
          }
          try {
            resolve([200, JSON.parse(base64_decode(data))]);
          } catch (err) {
            console.error('Erro ao decodificar a resposta :', err);
            reject([500, { message: rejectMessage }]);
          }
          return;
        }

        if (parseType === 'jsonBase64') {
          resolve([200, JSON.parse(base64_decode(data))]);
          return;
        }

        if (parseType === 'base64') {
          resolve([200, base64_decode(data)]);
          return;
        }

        resolve([200, data]);
      },
      error: function (xhr) {
        console.error('Erro na requisição :', xhr);
        handleHistoryNfeError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    console.error('Erro ao configurar a requisição :', err);
    reject([500, { message: err + ' Server Error' }]);
  }
});

const RestHistoryNfePost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'deleteMarcador':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'deleteMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downXML':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'dwnXml',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadLote':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'downloadLote',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadLoteTodas':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'downloadLoteTodas',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'relComplementarProdutosLote':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'relComplementarProdutosLote',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'relComplementarProdutosLoteTodas':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'relComplementarProdutosLoteTodas',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'enviaArquivosEmail':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'enviaArquivosEmail',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'enviaArquivosEmailTodos':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'enviaArquivosEmailTodos',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'eventos':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'situacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
        extraData: { tipo: 1 },
      });
    case 'hideMarcador':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'hideMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'investigar':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'investigar',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'manifestacao':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'manifestacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'pesqNfe':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'pesqNfe',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'pesqNfeResumido':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'pesqNfeResumido',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        safeParse: true,
      });
    case 'printDanfe':
      return ajaxHistoryNfeEvent({
        type: 'Get',
        pp: 'nfe',
        ll: 'printDanfe',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'printDaEvento':
      return ajaxHistoryNfeEvent({
        type: 'Get',
        pp: 'nfe',
        ll: 'printDaEvento',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadEventoXml':
      return ajaxHistoryNfeEvent({
        type: 'Get',
        pp: 'nfe',
        ll: 'downloadEventoXml',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadDanfeZip':
      return ajaxHistoryNfeEvent({
        type: 'Get',
        pp: 'nfe',
        ll: 'downloadDanfeZip',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'printComplementarProd':
      return ajaxHistoryNfeEvent({
        type: 'Get',
        pp: 'nfe',
        ll: 'printComplementarProd',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'printComprovanteManifestacao':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'printComprovanteManifestacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'salvaConfigTabela':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'updateConfigTabela',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost, null, 2))],
        tk: token,
        extraData: { cf: Arr_.dataPost },
      });
    case 'salvaNovoMarcador':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'salvaNovoMarcadorNfe',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        extraData: { tipo: 'nfe' },
      });
    case 'setMarcador':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'setMarcador',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'showMarcador':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'showMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'situacao':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'situacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
        extraData: { tipo: 0 },
      });
    case 'updateAnotacao':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'updateAnotacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadLoteForn':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'downloadLoteForn',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'analiseIa':    
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'analiseIa',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'analiseIaLote':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'analiseIaLote',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getQuotaHistoricoIaLote':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'getQuotaHistoricoIaLote',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getHistoricoDownloads':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'getHistoricoDownloads',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'gerarLinkDownload':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'gerarLinkDownload',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'gerarLinkDownloadIndividual':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'gerarLinkDownloadIndividual',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'printDanfeFromHistory':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'printDanfeFromHistory',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'downloadDanfeZipFromHistory':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'downloadDanfeZipFromHistory',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'salvarObservacao':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'salvarObservacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'estenderExpiracao':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'estenderExpiracao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'excluirDownload':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'excluirDownload',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'buscarDownloadIdentico':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'buscarDownloadIdentico',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'enviarLinkEmail':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'enviarLinkEmail',
        // btoa(unescape(encodeURIComponent(...))) garante encoding correto de acentos e caracteres > U+00FF
        dd: [base64_encode(emp), base64_encode(uid), btoa(unescape(encodeURIComponent(JSON.stringify(Arr_.dataPost))))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getLogsEnviosEmail':
      return ajaxHistoryNfeEvent({
        type: 'Post',
        pp: 'nfe',
        ll: 'getLogsEnviosEmail',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
  }
};

const RestHistoryNfeGet = (config) => {
  const caminho = config.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'getConfigTableNfe':
      return ajaxHistoryNfeEvent({
        type: 'Get',
        pp: 'nfe',
        ll: 'getConfigTableNfe',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
      });
    case 'getItensNfe':
      return ajaxHistoryNfeEvent({
        type: 'Get',
        pp: 'nfe',
        ll: 'getItensNfe',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getMarcadores':
      return ajaxHistoryNfeEvent({
        type: 'Get',
        pp: 'nfe',
        ll: 'getMarcadores',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getVinculados':
      return ajaxHistoryNfeEvent({
        type: 'Get',
        pp: 'nfe',
        ll: 'getVinculadosNfe',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getUltimaConsulta':
      return ajaxHistoryNfeEvent({
        type: 'Get',
        pp: 'nfe',
        ll: 'getUltimaConsultaNfe',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
  }
};

export { RestHistoryNfePost, RestHistoryNfeGet };